<div class="row a_center" [ngClass]="{'active': isActive}">
    <mat-checkbox [(ngModel)]="isActive"><span>{{text}}</span></mat-checkbox>
    <button *ngIf="isActive" (click)="clear()">clear</button>
</div>